import React, { useState, useEffect } from "react";
import { 
    Box, 
    Typography, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    Paper, 
    TextField, 
    Divider,
    Pagination
} from "@mui/material";
import "./TopProducts.css";

export default function TopProducts({ data }) {
    const [search, setSearch] = useState("");
    
   
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;  

    const safeData = data || [];

    const filteredData = safeData.filter(item =>
        item.productName.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

    useEffect(() => {
        setPage(1);
    }, [search]);

    return (
        <Box className="top-products-box">
            <Box className="top-products-header">
                <Typography variant="h6" className="top-products-title">
                    Ən Çox Satılan Məhsullar
                </Typography>
                <TextField
                    size="small"
                    placeholder="Axtar..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </Box>

            <Divider sx={{ my: 1 }} />

            <TableContainer component={Paper} className="top-products-table-container">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sıra</TableCell>
                            <TableCell>Məhsul Adı</TableCell>
                            <TableCell>Kategoriya</TableCell>
                            <TableCell>Alt Kateqoriya</TableCell>
                            <TableCell>Satıldı</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedData.length > 0 ? (
                            paginatedData.map((item, idx) => (
                                <TableRow key={idx}>
                                   
                                    <TableCell>{startIndex + idx + 1}</TableCell>
                                    <TableCell>{item.productName}</TableCell>
                                    <TableCell>{item.categoryName}</TableCell>
                                    <TableCell>{item.subcategoryName}</TableCell>
                                    <TableCell>
                                        {item.sold}{" "}
                                        {(item.subcategoryName === "Motor yağı" || item.subcategoryName === "Transmissiya yağı")
                                            ? "Litr"
                                            : "Ədəd"}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow className="no-data-row">
                                <TableCell colSpan={5} align="center">
                                    Məlumat tapılmadı
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

          
            {totalPages > 1 && (
    <Box className="top-products-pagination-wrapper">
        <Pagination 
            count={totalPages} 
            page={page} 
            onChange={(e, value) => setPage(value)} 
            color="primary" 
            size="small"
            shape="rounded"
            variant="outlined"
        />
    </Box>
)}
        </Box>
    );
}